// Komponent do wyświetlania priorytetu zadania

import React, { FC } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import calendarIcon from 'assets/icons/calendar.svg';
import urgentIcon from 'assets/icons/urgent-icon.svg';

import styles from 'theme/components/wise/WiseTable/components/WisePriorityComponent/WisePriorityComponent.module.scss';

interface IWisePriorityComponentProps {
  priority: number;
}

const WisePriorityComponent: FC<IWisePriorityComponentProps> = ({ priority }) => {
  const { t } = useTranslation();
  const isUrgent = priority === 1;

  return (
    <div className={classnames(styles.priorityWrapper, { [styles.urgent]: isUrgent })}>
      <img
        src={isUrgent ? urgentIcon : calendarIcon}
        alt={isUrgent ? 'Urgent' : 'Normal'}
        className={styles.icon}
      />
      <p>{isUrgent ? t('Pilne') : t('Pozostałe')}</p>
    </div>
  );
};

export default WisePriorityComponent;
